"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var FormNavigationSwitch = /** @class */ (function (_super) {
    __extends(FormNavigationSwitch, _super);
    function FormNavigationSwitch() {
        var _this = _super.call(this, constants_1.DATA_CONTACT_FORM_SWITCH) || this;
        if (!_this.getElement()) {
            return _this;
        }
        _this.contactFormSwitch = document.querySelector("[".concat(constants_1.DATA_CONTACT_FORM_SWITCH, "]"));
        _this.contactFormItem = _this.getChildElements("[".concat(constants_1.DATA_CONTACT_FORM_ITEM, "]"));
        _this.contactForm = _this.getChildElements("[".concat(constants_1.DATA_CONTACT_FORM, "]"));
        _this.getActiveForm();
        _this.contactFormItem.forEach(function (element) {
            element.addEventListener('click', function () {
                _this.removeActiveTab();
                _this.toggleForm(element);
            });
        });
        return _this;
    }
    /**
     * Toggle Form
     * @private
     */
    FormNavigationSwitch.prototype.toggleForm = function (tab) {
        var _this = this;
        var formTabId = tab.getAttribute('data-contact-form-item');
        tab.classList.add('active');
        this.contactForm.forEach(function (form) {
            var formID = form.getAttribute('data-contact-form');
            if (formID === formTabId) {
                _this.showForm(form);
            }
            else {
                _this.hideForm(form);
            }
        });
    };
    /**
     * Get actual Form via URL
     * @private
     */
    FormNavigationSwitch.prototype.getActiveForm = function () {
        var url = window.location.toString();
        var subUrl = url.slice(-4);
        var activeFormID = subUrl.split('-')[1];
        var actionString = 'action';
        var activeFormAvailable = url.includes(actionString);
        this.contactForm.forEach(function (form) {
            if (activeFormAvailable) {
                form.classList.remove('active');
            }
            var formID = form.getAttribute('data-contact-form');
            if (formID == activeFormID) {
                form.classList.add('active');
            }
        });
        this.contactFormItem.forEach(function (tab) {
            if (activeFormAvailable) {
                tab.classList.remove('active');
            }
            var formID = tab.getAttribute('data-contact-form-item');
            if (formID == activeFormID) {
                tab.classList.add('active');
            }
        });
    };
    /**
     * Show Form (add active)
     * @param form: Form
     * @private
     */
    FormNavigationSwitch.prototype.showForm = function (form) {
        form.classList.add('active');
    };
    /**
     * Hide Form (remove active)
     * @param form: Form
     * @private
     */
    FormNavigationSwitch.prototype.hideForm = function (form) {
        form.classList.remove('active');
    };
    /**
     * Hide Form (remove active)
     * @param tab: Form Tab switch
     * @private
     */
    FormNavigationSwitch.prototype.removeActiveTab = function () {
        this.contactFormItem.forEach(function (tab) {
            tab.classList.remove('active');
        });
    };
    return FormNavigationSwitch;
}(abstractComponent_1.default));
exports.default = FormNavigationSwitch;
